import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Typography from "@mui/material/Typography"; // Import Typography
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min'; // Import Bootstrap JavaScript

const GloriaMrio = () => {
    return (
        <div className="container-fluid">
        <style>
            {`
            @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
            body {
              font-family: 'Roboto';
            }
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
            `}
        </style>
          {/* Banner Image: Only visible when Home link is active */}
        <div className="home-banner">
          <img src="/Banner 2.png" alt="Footprint Banner" style={{ width: '100%', height: '350px', objectFit: 'cover' }}/>
        </div>
        <section id="gloria-mrio" className="container">
                <div className="col" style={{paddingBottom: '2em',}}>
                <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
                    GLORIA MRIO
                  </h3>                    
                    <Typography variant="body1" paragraph sx={{textAlign: 'left',  fontFamily: 'Roboto'}}>
                    The Global Resource Input-Output Assessment (GLORIA) database is a Multi-Regional Input-Output (MRIO) database that was built using the IELab infrastructure, by the University of Sydney for the UNEP International Resource Panel (UNEP IRP) in the context of the update of the material footprint accounts forming part of the <a href="https://www.resourcepanel.org/global-material-flows-database" target="_blank" rel="noopener noreferrer">UNEP IRP Global Material Flows Database</a>.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{textAlign: 'left',  fontFamily: 'Roboto'}}>
                    The MRIO tables distinguish the common components, such as intermediate transactions block T, final demand block Y, and value-added block V, and are compiled in five levels of valuations. In the MRIO design specific focus was set on the capability to do resource flow analysis. The dimensions of the MRIO time series are the following:
                    <ul>
                    <li>Years covered: 1990-2024.</li>
                    <li> Number of regions: 164.</li>
                    <li> Number of industry sectors: 97.</li>
                    <li>Number of commodity sectors: 97 (labels are identical to industry sectors).</li>
                    <li>Number of final demand agents: 6.</li>
                    <li>Number of value-added categories: 6.</li>
                    <li>Number of valuations: 5.</li>
                    <li>Unit for monetary values: thousand USD current price.</li>
                    </ul>
                    </Typography>
                    <Typography variant="body1" paragraph sx={{textAlign: 'left',  fontFamily: 'Roboto'}}>
                    The GLORIA database is a homogenous multi-regional supply-use table featuring identical sector labels for both the industry and commodity sectors. Further, the supply tables are as of now strictly diagonal. While it is acknowledged that co-production should be recorded in the supply tables, this is at present future work and requires further data mining.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{textAlign: 'left',  fontFamily: 'Roboto', paddingBottom: '2em'}}>
                    More detailed information, including the construction approach for the MRIO table, lists the source data sets that were used, the quality checks that were performed, and holds additional, method- and data-specific information about the construction process, is provided in the Global Resource Input Output Assessment (GLORIA) database: <a href="https://ielab.info/assets/resources/Technical_Documentation_GLORIA_20210913.pdf" target="_blank" rel="noopener noreferrer">Technical Documentation</a>, as well as on the <a href="https://ielab.info/labs/ielab-gloria" target="_blank" rel="noopener noreferrer">Industrial Ecology Virtual Laboratory (IELab)</a> website.
                    </Typography>
                </div>
        </section>
        </div>
    );
};

export default GloriaMrio;
